// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us/:page',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
    analytics: path(ROOTS_DASHBOARD, '/analytics'),
    banking: path(ROOTS_DASHBOARD, '/banking'),
    booking: path(ROOTS_DASHBOARD, '/booking')
  },
  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  customer: {
    // root: path(ROOTS_DASHBOARD, '/customer'),
    profile: path(ROOTS_DASHBOARD, '/customer/profile/6241402802cdd6ef22e09422'),
    // cards: path(ROOTS_DASHBOARD, '/customer/cards'),
    list: path(ROOTS_DASHBOARD, '/customer/list'),
    newCustomer: path(ROOTS_DASHBOARD, '/customer/new'),
    editById: path(ROOTS_DASHBOARD, `/customer/edit/6241402802cdd6ef22e09422`),
    account: path(ROOTS_DASHBOARD, '/customer/account')
  },
  depo: {
    root: path(ROOTS_DASHBOARD, '/depo'),
    // shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/depo/product/:id'),
    productById: path(ROOTS_DASHBOARD, '/depo/product/:id'),
    list: path(ROOTS_DASHBOARD, '/depo/list'),
    newProduct: path(ROOTS_DASHBOARD, '/depo/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    editProduct: path(ROOTS_DASHBOARD, '/depo/product/edit/:id'),
    // checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    // invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    // shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    // product: path(ROOTS_DASHBOARD, '/depo/product/:id'),
    // productById: path(ROOTS_DASHBOARD, '/depo/product/nike-air-force-1-ndestrukt'),
    // list: path(ROOTS_DASHBOARD, '/depo/list'),
    // newProduct: path(ROOTS_DASHBOARD, '/depo/product/new'),
    // editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    // editProduct: path(ROOTS_DASHBOARD, '/depo/product/edit/:id'),
    newInvoice: path(ROOTS_DASHBOARD, '/invoice/create'),
    invoice: path(ROOTS_DASHBOARD, '/invoice/invoice')
  },
  panel: {
    root: path(ROOTS_DASHBOARD, '/panel'),
    newBlock: path(ROOTS_DASHBOARD, '/panel/create'),
  },
  accounting: {
    root: path(ROOTS_DASHBOARD, '/accounting'),
    // shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    single: path(ROOTS_DASHBOARD, '/accounting/transaction/single/62497332a0820b0fb451f1f7'),
    // productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/accounting/transaction/list'),
    newTransaction: path(ROOTS_DASHBOARD, '/accounting/transaction/new'),
    edit: path(ROOTS_DASHBOARD, '/accounting/transaction/edit/62497332a0820b0fb451f1f7'),
    // checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    // invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  tools: {
    root: path(ROOTS_DASHBOARD, '/tools/workflow'),
    fileManager: path(ROOTS_DASHBOARD, '/tools/filemanager'),
    single: path(ROOTS_DASHBOARD, '/tools/workflow'),
    category: path(ROOTS_DASHBOARD, '/tools/category'),
    // productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    // list: path(ROOTS_DASHBOARD, '/accounting/transaction/list'),
    // newTransaction: path(ROOTS_DASHBOARD, '/accounting/transaction/new'),
    // edit: path(ROOTS_DASHBOARD, '/accounting/transaction/edit/62497332a0820b0fb451f1f7'),
    // checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    // invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  ticket: {
    root: path(ROOTS_DASHBOARD, '/ticket/list'),
    // fileManager: path(ROOTS_DASHBOARD, '/tools/filemanager'),
    // single: path(ROOTS_DASHBOARD, '/tools/workflow'),
    // productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/ticket/list'),
    // newTransaction: path(ROOTS_DASHBOARD, '/accounting/transaction/new'),
    // edit: path(ROOTS_DASHBOARD, '/accounting/transaction/edit/62497332a0820b0fb451f1f7'),
    // checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    // invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
